import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

export default class extends Controller {
  static targets = ['nav', 'scrollable'];

  connect() {
    this.initScrollSpy();
  }

  disconnect() {
    if (this.scrollSpyInstance) {
      this.scrollSpyInstance.dispose();
      this.scrollSpyInstance = null;
    }
  }

  initScrollSpy() {
    if (!this.hasScrollableTarget) return;

    const existing = bootstrap.ScrollSpy.getInstance(this.scrollableTarget);
    if (existing) existing.dispose();

    this.scrollSpyInstance = new bootstrap.ScrollSpy(this.scrollableTarget, {
      target: `#${this.navTarget.id}`,
      offset: 80,
      smoothScroll: true,
    });
  }

  scrollToActive() {
    const active = this.navTarget.querySelector('.nav-link.active');
    if (!active) return;

    active.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }
}
